"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GenplanContainer = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _GenplanImage = require("../../components/GenplanImage");
var _GenplanObject = require("../../components/GenplanObject");
var _GenplanLayout = require("../../components/GenplanLayout");
var _hooks = require("../../hooks");
var _filters = require("../../utils/filters");
var _Filters = require("../../components/Filters");
var _useFocusedObject = require("../../hooks/useFocusedObject");
var _context = require("./context");
var _FullscreenControl = require("../../components/FullscreenControl");
var _ZoomControls = require("../../components/ZoomControls");
const _excluded = ["id"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const GenplanContainer = _ref => {
  let {
    data: {
      image,
      objects,
      filters
    },
    onView,
    onPolygonClick,
    onTooltipClick,
    onTooltipPhoneShow,
    isFullscreen,
    toggleFullscreen,
    onFilterChange,
    focusedOfferId
  } = _ref;
  const genplanRef = React.useRef(null);
  const genplanImageRef = React.useRef(null);
  const genplanImageSize = (0, _hooks.useGenplanImageSize)(genplanImageRef);
  const containerRef = (0, _hooks.useGenplanShowHandler)(onView);
  const {
    subscribeToTransform,
    zoom,
    resetZoom
  } = (0, _hooks.usePanzoom)(genplanRef);
  const handleFullscreenChange = React.useCallback(() => {
    resetZoom();
    setTimeout(toggleFullscreen);
  }, [resetZoom, toggleFullscreen]);
  (0, _hooks.useLockedBody)(isFullscreen);
  const [preparedFilters, onChange] = (0, _hooks.useFilters)(filters, onFilterChange);
  const filteredObjects = React.useMemo(() => (0, _filters.filterObjects)(objects, preparedFilters), [preparedFilters, objects]);
  const focusObject = (0, _useFocusedObject.useFocusedObject)(focusedOfferId);
  const genplanContextValue = React.useMemo(() => ({
    genplanSize: genplanImageSize,
    subscribeToTransform
  }), [genplanImageSize, subscribeToTransform]);
  return /*#__PURE__*/React.createElement(_GenplanLayout.GenplanLayout, {
    ref: containerRef,
    isFullscreen: isFullscreen,
    size: genplanImageSize,
    genplan: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_GenplanImage.GenplanImage, (0, _extends2.default)({
      url: image
    }, genplanImageSize, {
      imageRef: genplanImageRef,
      ref: genplanRef,
      isFullscreen: isFullscreen
    })), !!genplanImageSize.width && !!genplanImageSize.height && /*#__PURE__*/React.createElement(_context.GenplanContext.Provider, {
      value: genplanContextValue
    }, filteredObjects.map(_ref2 => {
      let {
          id
        } = _ref2,
        rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
      return /*#__PURE__*/React.createElement(_GenplanObject.GenplanObject, (0, _extends2.default)({
        key: id,
        id: id,
        onPolygonClick: onPolygonClick,
        onTooltipClick: onTooltipClick,
        onTooltipPhoneShow: onTooltipPhoneShow,
        isFullscreen: isFullscreen,
        focused: focusObject(id)
      }, rest));
    }))),
    controls: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_FullscreenControl.FullscreenControl, {
      onToggle: handleFullscreenChange,
      isFullscreen: isFullscreen
    }), /*#__PURE__*/React.createElement(_ZoomControls.ZoomControls, {
      onZoom: zoom
    })),
    filters: preparedFilters ? /*#__PURE__*/React.createElement(_Filters.Filters, {
      items: preparedFilters,
      onChange: onChange
    }) : null
  });
};
exports.GenplanContainer = GenplanContainer;